// @flow
import React from 'react';
import type { Bloc, BlocContent } from 'types/NewsletterBloc';

import ContentBloc from 'components/newsletter/blocs/ContentBloc';

type Props = {
  description: Array<Bloc|BlocContent>,
};

const Description = ({ description }: Props): any => {
  return description.map((blocFigure, index) =>
    <ContentBloc key={index} {...blocFigure} />
  );
};

export default Description;
